module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a6-0-4ea6c1f00ea04cf95f3537d844da312e.jpg";